import { colors } from '@lmc/common/constants'
import { Icon, Popover, Text } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'
import {
  LinkComponent,
  PopoverTextBox
} from '../../../../../components/generic'
import PRNCell from './PRNCell'
import PRNPopoverLogs from './PRNPopoverLogs'

/**
@description Renders a MAR Chart Cell

@param {object} value. The cell value object.

{
    log: {
        title: Types.String,
        description: Types.String,
        id: '123456',
        loggedBy: { name: { first... } },
        timeLogged: "2021-06-01T00:00:00.000Z",
    }
    reasonCode: "A"
    taken: false
}

@returns {function} MARChartCell
*/

const renderCheckIcon = (props) => {
  return (
    <div>
      <Icon color={colors.successgreen} name="CheckOutlined" />
    </div>
  )
}

const renderReasonCode = (props) => {
  const {
    value: { reasonCode }
  } = props

  return (
    <Text style={styles.reasonCode} as="h5">
      {reasonCode}
    </Text>
  )
}

const renderCellContent = (props) => {
  const { value } = props

  if (value && value.taken) {
    return value.type === 'PRN' ? (
      <div>
        <PRNCell {...props} />
      </div>
    ) : (
      renderCheckIcon(props)
    )
  }
  if (value && !value.taken) {
    return renderReasonCode(props)
  }

  return null
}

// Render cell function

const renderCell = (props) => {
  const { value } = props

  if (!value) return null

  const { log, prnRounds, type } = value
  const content =
    type === 'PRN' ? (
      <PRNPopoverLogs logs={prnRounds.map((round) => round.log)} />
    ) : !log || !log?.loggedBy ? null : (
      <div style={styles.textBoxContainer}>
        <LinkComponent to={`/logs/${log.id}`}>
          <PopoverTextBox
            carerName={log?.loggedBy.name}
            details={log.description}
            timestamp={dayjs(log.timeLogged).format('DD-MM-YYYY • HH:mm')}
            title={log.title}
          />
        </LinkComponent>
      </div>
    )

  return (
    <Popover
      arrowPointAtCenter
      content={content}
      overlayClassName="lmc-generic-popover"
      placement="bottomLeft"
    >
      {renderCellContent({ ...props, prnRounds })}
    </Popover>
  )
}

// Main Render Function

export default function MARChartCell(props) {
  return <div style={styles.container}>{renderCell(props)}</div>
}

MARChartCell.propTypes = {
  value: PropTypes.object.isRequired
}

const styles = {
  checkIcon: {
    color: colors.successgreen,
    fontSize: 16
  },
  container: {
    cursor: 'pointer'
  },
  prnCellContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  reasonCode: {
    color: colors.red,
    lineHeight: '22px'
  },
  textBoxContainer: {
    margin: '-12px -16px',
    width: 285
  }
}
